<template>
  <div
    class="class-section cursor-pointer"
    :class="{
      'is-nearest-attended': isNearest && isAttended,
      'is-nearest-absent': isNearest && !isAttended,
    }"
  >
    <div class="class-section__basic-info mb-2">
      <div class="class-section__basic-info--title">
        {{ title || '' }}
      </div>
      <div class="class-section__basic-info--date">
        {{ formatDate(date) }}
      </div>
    </div>
    <div class="mb-2 text-body-2">
      <span v-if="!isAttended" class="red--text">Chưa điểm danh</span>
      <span v-else class="green--text">{{ lastUpdateBy }} đã điểm danh </span>
    </div>
    <div class="class-section__advanced-info d-flex justify-space-between align-center">
      <div class="class-section__advanced-info--title">
        <div
          v-html="
            `Có mặt <span style='color:#3E3E3C; font-size: 16px;'>${data.countAttended}</span>/${classData.students.length}`
          "
        />
      </div>
      <div v-if="!isFutureDate">
        <v-tooltip color="grey darken-3" top close-delay="10" eager>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <v-icon color="green" v-if="isAttended">mdi-check-circle-outline</v-icon>
              <v-icon color="red" v-else>mdi-alert-circle-outline</v-icon>
            </div>
          </template>
          <span>
            {{ isAttended ? 'Đã điểm danh' : 'Chưa điểm danh' }}
          </span>
        </v-tooltip>
      </div>
    </div>
    <div class="d-flex justify-space-between align-center mt-4" v-if="!isFutureDate">
      <v-btn class="px-0" text color="primary" @click="$emit('onSelectClass')">Điểm danh</v-btn>
      <v-menu offset-y bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon small>
            <v-icon color="#0D47A1">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list class="py-0">
          <SendMessageAttendance :id="id" :date="date" />
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import get from 'lodash-es/get'
import SendMessageAttendance from './SendMessageAttendance.vue'

export default {
  components: { SendMessageAttendance },
  props: {
    data: Object,
    isNearest: Boolean,
  },
  data() {
    return {
      isActiveAbsent: false,
      isActiveAttended: false,
      title: '',
      date: '',
      lastUpdateBy: '',
      attendedCount: 0,
      isAttended: false,
      id: '',
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapState({
      classData(state) {
        return state['class'].clazz
      },
    }),
    isFutureDate() {
      if (!this.date) return false
      return new Date() < new Date(this.date)
    },
  },
  methods: {
    ...mapActions('postCreate', ['sendDiligence']),
    formatDate(value) {
      return value && value.length ? moment(value).format('DD/MM/YYYY') : '--/--/--'
    },
    handleData(val = {}) {
      if (val && val.id) {
        this.id = val.id
        this.title = `Buổi ${val.index}`
        this.date = val.date
        this.lastUpdateBy = get(val, 'checkAttendedBy.name', 'Admin')
        this.isAttended = val.isAttended
        if (val.attendances) {
          this.getAttendanceStatistic(val.attendances)
        }
      }
    },
    getAttendanceStatistic(attendances = []) {
      const currentStudentIds = this.getClassStudent.map((x) => x.studentId)
      const currentStudentAttendances = attendances.filter((x) => currentStudentIds.includes(x.student))
      this.attendedCount = currentStudentAttendances.filter((x) => x.status === 'attended').length
    },
  },
  watch: {
    data: {
      handler(val) {
        if (val && val.id) {
          this.handleData(val)
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.class-section {
  width: 100%;
  height: 100%;
  border: 1px solid #e6e4eb;
  padding: 12px;
  border-radius: 4px;
  background-color: white;
  &__basic-info {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: auto;
    &--title {
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: #3e3e3c;
    }
    &--date {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      color: #797979;
    }
  }
  &__attendance-info {
    font-size: 14px;
    font-weight: 400;
    color: red;
  }
  &__advanced-info {
    display: flex;
    justify-content: space-between;
    &--title {
      font-size: 14px;
      font-weight: 400;
      color: #9c9c9c;
    }
  }
}

.is-nearest-attended {
  border: 1px solid #4bca81;
}

.is-nearest-absent {
  border: 1px solid #ffc410;
}
</style>
